import { render, staticRenderFns } from "./SearchFailed.vue?vue&type=template&id=4bf1b02d&"
import script from "./SearchFailed.vue?vue&type=script&lang=js&"
export * from "./SearchFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports